import { render, staticRenderFns } from "./WriteOffGoodsList.vue?vue&type=template&id=084795b6&scoped=true&"
import script from "./WriteOffGoodsList.vue?vue&type=script&lang=js&"
export * from "./WriteOffGoodsList.vue?vue&type=script&lang=js&"
import style0 from "./WriteOffGoodsList.vue?vue&type=style&index=0&id=084795b6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084795b6",
  null
  
)

export default component.exports